import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Children, cloneElement, useState, useMemo, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Manager, Popper, Reference } from 'react-popper';
import { StyleSheet, text, useToken, useStyles } from '@rexlabs/styling';
var defaultStyles = StyleSheet({
  tooltip: {
    paddingTop: function paddingTop(_ref) {
      var token = _ref.token;
      return token('tooltip.padding.top', token('spacing.s', '.8rem'));
    },
    paddingRight: function paddingRight(_ref2) {
      var token = _ref2.token;
      return token('tooltip.padding.right', token('spacing.s', '.8rem'));
    },
    paddingBottom: function paddingBottom(_ref3) {
      var token = _ref3.token;
      return token('tooltip.padding.bottom', token('spacing.s', '.8rem'));
    },
    paddingLeft: function paddingLeft(_ref4) {
      var token = _ref4.token;
      return token('tooltip.padding.left', token('spacing.s', '.8rem'));
    },
    marginTop: function marginTop(_ref5) {
      var token = _ref5.token;
      return token('tooltip.margin.top', 0);
    },
    marginRight: function marginRight(_ref6) {
      var token = _ref6.token;
      return token('tooltip.margin.right', 0);
    },
    marginBottom: function marginBottom(_ref7) {
      var token = _ref7.token;
      return token('tooltip.margin.bottom', 0);
    },
    marginLeft: function marginLeft(_ref8) {
      var token = _ref8.token;
      return token('tooltip.margin.left', 0);
    },
    backgroundColor: function backgroundColor(_ref9) {
      var token = _ref9.token;
      return token('tooltip.background.color', token('color.container.static.dark', 'black'));
    },
    minWidth: function minWidth(_ref10) {
      var token = _ref10.token;
      return token('tooltip.minWidth', 'auto');
    },
    maxWidth: function maxWidth(_ref11) {
      var token = _ref11.token;
      return token('tooltip.maxWidth', '20rem');
    },
    borderRadius: function borderRadius(_ref12) {
      var token = _ref12.token;
      return token('tooltip.borderRadius', '.4rem');
    },
    zIndex: function zIndex(_ref13) {
      var token = _ref13.token;
      return token('tooltip.zIndex', token('zIndex.base', 0) + 1);
    },
    '&, & p': _objectSpread({}, text.styles({
      target: 'tooltip',
      fallback: 'small.default',
      color: function color(_ref14) {
        var token = _ref14.token;
        return token('color.textStyle.body.contrast');
      }
    })),
    '& p': {
      paddingTop: 0,
      paddingBottom: function paddingBottom(_ref15) {
        var token = _ref15.token;
        return token('tooltip.paragraph.padding.bottom', token('spacing.xs', '.4rem'));
      },
      '&:last-child': {
        paddingBottom: 0
      }
    }
  },
  arrow: {
    position: 'absolute',
    transform: 'rotate(45deg)',
    background: function background(_ref16) {
      var token = _ref16.token;
      return token('tooltip.background.color', token('color.container.static.dark', 'black'));
    },
    zIndex: 1
  },
  arrowTop: {
    bottom: function bottom(_ref17) {
      var token = _ref17.token;
      return token('tooltip.arrowSize', _parseInt(token('arrow.size', 12)) / -2);
    }
  },
  arrowBottom: {
    top: function top(_ref18) {
      var token = _ref18.token;
      return token('tooltip.arrowSize', _parseInt(token('arrow.size', 12)) / -2);
    }
  },
  arrowLeft: {
    right: function right(_ref19) {
      var token = _ref19.token;
      return token('tooltip.arrowSize', _parseInt(token('arrow.size', 12)) / -2);
    }
  },
  arrowRight: {
    left: function left(_ref20) {
      var token = _ref20.token;
      return token('tooltip.arrowSize', _parseInt(token('arrow.size', 12)) / -2);
    }
  },
  content: {
    position: 'relative',
    zIndex: 2
  }
});
var enterTimer;
var leaveTimer; // We need unique ids for the aria attributes, so we simply use
// incremental ids for all tooltip instances

var counter = 0; // HACK: this way we avoid having to render a TooltipContext to be able to close
// the currently open tooltip immediately when hovering quickly over another
// tooltip

var currentOpen; // Adding a global event listener, so we don't need a listener for every
// tooltip instance

window.document.addEventListener('keydown', function (e) {
  if (currentOpen) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      currentOpen.close();
    }
  }
});

function Tooltip(_ref21) {
  var children = _ref21.children,
      Content = _ref21.Content,
      _ref21$placement = _ref21.placement,
      placement = _ref21$placement === void 0 ? 'top' : _ref21$placement,
      distanceProp = _ref21.distance;
  var s = useStyles(defaultStyles, 'Tooltip');
  var token = useToken();
  var arrowSize = token('tooltip.arrowSize', token('arrow.size', 12));
  var distance = token('tooltip.distance', distanceProp || arrowSize / 2);
  var child = Children.only(children);
  var uuid = useMemo(function () {
    return ++counter;
  }, []);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  function handleMouseEnter() {
    window.clearTimeout(leaveTimer);

    if (!isOpen) {
      if (currentOpen && currentOpen.uuid !== uuid) {
        if (token('toolip.behaviour.noDelay', true)) {
          currentOpen.close();
          setOpen(true);
        } else {
          enterTimer = _setTimeout(function () {
            setOpen(true);
            currentOpen.close();
          }, token('tooltip.delay', 400));
        }
      } else {
        enterTimer = _setTimeout(function () {
          return setOpen(true);
        }, token('tooltip.delay', 400));
      }
    }
  }

  function handleMouseLeave() {
    window.clearTimeout(enterTimer);

    if (isOpen) {
      leaveTimer = _setTimeout(function () {
        return setOpen(false);
      }, token('tooltip.delay', 400));
    }
  }

  function handleFocus() {
    setOpen(true);
  }

  function handleBlur() {
    setOpen(false);
  }

  useEffect(function () {
    var _currentOpen;

    if (isOpen) {
      currentOpen = {
        uuid: uuid,
        close: function close() {
          return setOpen(false);
        }
      };
    } else if (((_currentOpen = currentOpen) === null || _currentOpen === void 0 ? void 0 : _currentOpen.uuid) === uuid) {
      currentOpen = null;
    }
  }, [isOpen, setOpen, uuid]);
  return /*#__PURE__*/React.createElement(Manager, null, /*#__PURE__*/React.createElement(Reference, null, function (_ref22) {
    var ref = _ref22.ref;
    return child ? /*#__PURE__*/cloneElement(child, {
      ref: ref,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onFocus: handleFocus,
      onBlur: handleBlur,
      tabIndex: 0,
      'aria-describedby': uuid
    }) : null;
  }), /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(Popper, {
    placement: placement,
    modifiers: {
      flip: {
        enabled: true,
        boundariesElement: 'viewport'
      },
      offset: {
        enabled: true,
        offset: "0, ".concat(distance)
      },
      preventOverflow: {
        enabled: true,
        boundariesElement: 'viewport'
      },
      hide: {
        enabled: true
      }
    }
  }, function (_ref23) {
    var placement = _ref23.placement,
        ref = _ref23.ref,
        style = _ref23.style,
        arrowProps = _ref23.arrowProps;
    return isOpen && /*#__PURE__*/React.createElement("div", _extends({
      id: "tooltip-".concat(uuid),
      role: "tooltip",
      ref: ref,
      "data-placement": placement,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave
    }, s.with('tooltip')(style)), /*#__PURE__*/React.createElement("div", _extends({}, arrowProps, s.with('arrow', {
      arrowTop: placement === null || placement === void 0 ? void 0 : _startsWithInstanceProperty(placement).call(placement, 'top'),
      arrowBottom: placement === null || placement === void 0 ? void 0 : _startsWithInstanceProperty(placement).call(placement, 'bottom'),
      arrowLeft: placement === null || placement === void 0 ? void 0 : _startsWithInstanceProperty(placement).call(placement, 'left'),
      arrowRight: placement === null || placement === void 0 ? void 0 : _startsWithInstanceProperty(placement).call(placement, 'right')
    })(_objectSpread(_objectSpread({}, arrowProps), {}, {
      width: arrowSize,
      height: arrowSize
    })))), /*#__PURE__*/React.createElement("div", s('content'), /*#__PURE__*/React.createElement(Content, {
      isOpen: isOpen,
      setOpen: setOpen
    })));
  }), window.document.body));
}

export default Tooltip;